<!--
    描述：项目进度更新
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    <template v-else>
      <div>
        当前项目人中标人进度更新
        <span style="color: #0000FF">{{ tableData.length }}</span
        >次
      </div>
      <div class="mt10">
        <el-table
          :data="tableData"
          highlight-current-row
          row-key="id"
          border
          ref="table"
          style="width: 100%"
        >
          <el-table-column
            label="更新日期"
            prop="createDate"
            align="center"
            width="181"
          ></el-table-column>
          <el-table-column
            label="提交人"
            prop="submitter"
            show-overflow-tooltip
            align="center"
            width="121"
          >
          </el-table-column>
          <el-table-column
            label="已完成进度"
            prop="finishRate"
            align="center"
            width="151"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.finishRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            label="成果文件"
            min-width="151"
          >
            <template slot-scope="scope">
              <div
                style="display: flex;align-items: center;justify-content: space-between"
              >
                <div class="beyondHiding">
                  <span
                    v-for="(item, index) in scope.row.sysFiles"
                    :key="index"
                    class="link mr10"
                    type="text"
                    @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                  >
                    <el-popover
                      placement="top-start"
                      title="文件"
                      trigger="hover"
                    >
                      <div
                        v-for="e in scope.row.sysFiles"
                        class="link"
                        :key="e.id"
                        @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                      >
                        {{ e.fileName }}
                      </div>
                      <span slot="reference">{{ item.fileName }}</span>
                    </el-popover>
                  </span>
                </div>

                <el-button
                  class="bg"
                  v-if="scope.row.sysFiles.length > 0"
                  size="mini"
                  @click="downloadAll(scope.row.sysFiles)"
                  >批量下载</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="进度描述"
            prop="remark"
            show-overflow-tooltip
            width="261"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="viewProgress(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="w-table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </template>
    <!--弹窗-->
    <el-dialog
      :visible.sync="auditShow"
      width="50%"
      center
      title="查看进度"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="dialog-box">
        <el-form label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="填写日期：">
                {{ currentRowData.createDate }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提交人：">
                {{ currentRowData.submitter }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已完成进度：">
                {{ currentRowData.finishRate }}%
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="200px" label="能否按时按质完成项目：">
                {{ currentRowData.everFinish == 0 ? "否" : "是" }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="进度描述：">
                {{ currentRowData.remark }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成果文件：">
                <div
                  v-for="(item, index) in currentRowData.sysFiles"
                  :key="index"
                >
                  <div
                    class="link"
                    type="text"
                    @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                  >
                    {{ item.fileName }}
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="currentRowData.sysFiles">
              <el-button
                v-if="currentRowData.sysFiles.length > 0"
                class="bg"
                @click="downloadAll(currentRowData.sysFiles)"
                size="medium"
                >批量下载</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getScheduleUpdatePageList } from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
export default {
  name: "pro-progress-update",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      tableData: [],
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      currentRowData: {} // 当前行数据
    };
  },
  computed: {
    linkUrl() {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      return uploadUrl;
    }
  },
  methods: {
    // 获取列表数据
    getScheduleUpdatePageList() {
      getScheduleUpdatePageList({
        subProjectId: this.rowData.businessId,
        current: this.currentPage,
        size: this.pageSize
      }).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },

    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName)
    },

    // 批量下载
    downloadAll(list) {
      list.map(item => {
        const url = process.env.VUE_APP_UPLOAD_URL + item.fullFilePath;
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 防止影响页面
        iframe.style.height = 0; // 防止影响页面
        iframe.src = url;
        document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
        // 2分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
        setTimeout(() => {
          iframe.remove();
        }, 2 * 60 * 1000);
        // window.open(process.env.VUE_APP_UPLOAD_URL + item.fullFilePath, '_self', true)
      });
    },

    // 查看进度
    viewProgress(currentRowData) {
      this.auditShow = true;
      this.currentRowData = currentRowData;
    },

    // close 审查弹框
    closeDialog() {
      this.auditShow = false;
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getScheduleUpdatePageList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getScheduleUpdatePageList();
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped>
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
.el-button {
  background-color: #199ed8;
  color: white;
}

.bg {
  background-color: #ff9900 !important;
}

.link {
  color: #0000ff;
  cursor: pointer;
  /*border-bottom: 1px solid #0000ff;*/
  text-decoration: underline;
}

.beyondHiding {
  width: 700px;
  /*overflow-y: auto;*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
